import React from "react";
import './VisaReq.css';

// Import all images
import UserIcon from "../assets/ri_user-fill.svg";
import PassportIcon from "../assets/mdi_passport.svg";
import DocumentIcon from "../assets/ion_document.svg";
import IDBadgeIcon from "../assets/fa6-solid_id-badge.svg";

const VisaReq = () => {
    return (
        <div>
            <div className="sectiontitle">Visa <span>Requirement</span></div>

            <div className="visa-req-container">
                <div className="visa-req">
                    <img src={UserIcon} alt="User Icon"></img>
                    <div>Photo</div>
                </div>
                <div className="visa-req">
                    <img src={PassportIcon} alt="Passport Icon"></img>
                    <div>Passport</div>
                </div>
                <div className="visa-req">
                    <img src={DocumentIcon} alt="Document Icon"></img>
                    <div>Tax Document</div>
                </div>
                <div className="visa-req">
                    <img src={IDBadgeIcon} alt="ID Badge Icon"></img>
                    <div>Pan Card</div>
                </div>
            </div>
        </div>         
    );
}

export default VisaReq;
